// extracted by mini-css-extract-plugin
module.exports = {"loading":"QrpidLoading_loading__kliT3","loading__spinner":"QrpidLoading_loading__spinner__2Tl9T"};